import type { SimpleTableColumn } from "../../../../components/common/simple-table";
import type { PartnerDto } from "../../../../api";
import { Text } from "../../../../components/common/typography";
import { Button } from "../../../../components/common/button";

export function buildPartnersColumns(
  onView: (id: number) => void,
): SimpleTableColumn<PartnerDto>[] {
  return [
    {
      key: "id",
      label: "ID",
      className: "flex-shrink-0 w-16",
      render: (row) => (
        <Text variant="body" tone="muted">{row.id}</Text>
      ),
    },
    {
      key: "name",
      label: "Partner Name",
      className: "flex-[2] min-w-0",
      render: (row) => (
        <Text variant="bodyBold" tone="dark">{row.name || "—"}</Text>
      ),
    },
    {
      key: "email",
      label: "Email",
      className: "flex-[1.5] min-w-0",
      render: (row) => (
        <Text variant="body" tone="muted">{row.email || "—"}</Text>
      ),
    },
    {
      key: "phone",
      label: "Phone",
      className: "flex-1",
      render: (row) => <Text variant="body" tone="body">{row.phone || "—"}</Text>,
    },
    {
      key: "type",
      label: "Company Type",
      className: "flex-1",
      render: (row) => <Text variant="body" tone="body">{row.companyType || "—"}</Text>,
    },
    {
      key: "country",
      label: "Country",
      className: "flex-1",
      render: (row) => (
        <Text variant="body" tone="body">
          {(row.country as { name?: string } | null)?.name || "—"}
        </Text>
      ),
    },
    {
      key: "actions",
      label: "Actions",
      className: "flex-1 flex justify-end",
      render: (row) => (
        <Button
          variant="ghost"
          size="sm"
          className="!px-0 !text-textDark"
          onClick={(e) => { e.stopPropagation(); onView(row.id); }}
        >
          View
        </Button>
      ),
    },
  ];
}
